import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reset-pw h-full" }
const _hoisted_2 = { class: "grid grid-cols-9 place-content-center h-full" }
const _hoisted_3 = { class: "col-span-9 md:col-start-3 md:col-span-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-xl font-medium mb-1" }, "Reset Password", -1)
const _hoisted_5 = { class: "onboarding-card" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = {
  key: 0,
  class: "error-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResetPasswordForm = _resolveComponent("ResetPasswordForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ResetPasswordForm, {
              isSettings: false,
              onPwData: _ctx.passwordUpdateSubmitted
            }, null, 8, ["onPwData"]),
            (_ctx.state.responseError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.state.responseError), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}